<script>
    export default {
        name: "ProductPartnersList",
        props: {
            productId: Number,
            offerId: Number,
            isColorPreloader: Boolean,
            isLast: Boolean,
        },
        data() {
            return {
                partners: [],
                loading: true,
            };
        },
        computed: {
            icons() {
                return {
                    "Яндекс.Маркет": "ym.svg",
                    Wildberries: "wb.svg",
                    OZON: "ozon.svg",
                    "М.Видео": "mvideo.svg",
                    DNS: "dns.svg",
                    "re:Store": "restore.svg",
                    Эльдорадо: "eldorado.svg",
                    "Золотое яблоко": "gold-apple.png",
                    Технопарк: "technopark.svg",
                    "Азбука вкуса": "azbuka-vkusa.svg",
                    Kaspi: "kaspi.svg",
                    Каспи: "kaspi.svg",
                    "Kaspi.kz": "kaspi.svg",
                };
            },
            filteredPartners() {
                const partners = this.partners.filter((partner) => partner.link);
                const partnersByOffer = partners.filter((partner) => {
                    return partner.offerId === this.offerId;
                });
                return partnersByOffer.length > 0 ? partnersByOffer : partners;
            },
        },
        mounted() {
            if (!this.partners.length) {
                this.$store.productsApi
                    .getProductPartnerLinks({ productId: this.productId })
                    .then((partners) => {
                        this.loading = false;
                        this.partners = partners;
                    });
            }
        },
    };
</script>

<template>
    <div
        class="product-partners-list"
        :class="{ 'is-last': isLast || filteredPartners.length === 0 }"
    >
        <div
            v-if="!loading && filteredPartners.length > 0"
            class="product-partners-list__title"
        >
            В наличии у партнеров:
        </div>
        <div v-show="loading" class="product-partners-list__preloader">
            <preloader :show="true" :is-color="isColorPreloader" sm-size></preloader>
        </div>
        <div class="product-partners-list__list">
            <a
                v-for="partner in filteredPartners"
                :key="partner.id"
                :href="partner.link"
                target="_blank"
                class="product-partners-list__item"
            >
                <img
                    :src="`/static/assets/partners/${icons[partner.name]}`"
                    :alt="partner.name"
                />
                <span class="desktop-hidden">{{ partner.name }}</span>
                <div class="product-partners-list__tooltip">{{ partner.name }}</div>
            </a>
        </div>
    </div>
</template>

<style lang="scss">
    .product-partners-list {
        &:not(.is-last) {
            margin-bottom: 24px;
            @include bp($bp-desktop-sm) {
                margin-bottom: 58px;
            }
        }
    }

    .product-partners-list__preloader {
        position: relative;
        height: 200px;
    }

    .product-partners-list__title {
        margin-bottom: 16px;
        color: var(--primary-text);
        font-size: 16px;
        line-height: 18px;
        @include bp($bp-desktop-sm) {
            margin-bottom: 24px;
        }
    }

    .product-partners-list__list {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -4px -16px;
    }

    .product-partners-list__item {
        display: flex;
        align-items: center;
        width: calc(50% - 8px);
        margin: 0 4px 16px;
        img {
            @include box(48px);
            flex-shrink: 0;
            border-radius: 10px;
        }
        span {
            margin-left: 4px;
            color: #454f5b;
            font-size: 12px;
            line-height: 18px;
        }
        @include bp($bp-mobile-xs) {
            span {
                margin-left: 8px;
            }
            img {
                transition: opacity 0.2s ease-in;
            }
        }
        @include bp($bp-desktop-sm) {
            position: relative;
            @include box(48px);
            &:hover {
                img {
                    opacity: 0.7;
                }
                .product-partners-list__tooltip {
                    display: block;
                }
            }
        }
    }

    .product-partners-list__tooltip {
        display: none;
        @include bp($bp-desktop-sm) {
            position: absolute;
            top: calc(100% + 16px);
            color: var(--primary-text);
            font-weight: 500;
            font-size: 16px;
            line-height: 18px;
        }
    }
</style>
